import {format} from 'date-fns'
import './AppointmentModal.css'

interface AppointmentModalProps {
  title: string
  date: string
  meetingLocation?: string | null
  typeAppointment?: string | null
  comment?: string | null
  leadName?: string | null
  stageName?: string | null
  pipelineName?: string | null
  onClose: () => void
}

export const AppointmentModal = ({
  title,
  date,
  meetingLocation,
  typeAppointment,
  comment,
  leadName,
  stageName,
  pipelineName,
  onClose,
}: AppointmentModalProps) => {
  const parsed = new Date(date)
  const dateLabel = Number.isNaN(parsed.getTime()) ? 'N/R' : format(parsed, 'MMM dd, yyyy')
  const timeLabel = Number.isNaN(parsed.getTime()) ? 'N/R' : format(parsed, 'hh:mm a')

  return (
    <div className='appointment-modal-backdrop' onClick={onClose}>
      <div className='appointment-modal-content' onClick={(e) => e.stopPropagation()}>
        <div className='appointment-modal-header'>
          <h3 className='appointment-modal-title'>
            <i className='bi bi-calendar-check me-2'></i>
            Appointment Summary
          </h3>
          <button className='appointment-modal-close' onClick={onClose}>
            <i className='bi bi-x-lg'></i>
          </button>
        </div>
        <div className='appointment-modal-body'>
          <div className='appointment-modal-row'>
            <span className='appointment-modal-label'>Title</span>
            <span className='appointment-modal-value'>{title}</span>
          </div>
          <div className='appointment-modal-row'>
            <span className='appointment-modal-label'>Date</span>
            <span className='appointment-modal-value'>{dateLabel}</span>
          </div>
          <div className='appointment-modal-row'>
            <span className='appointment-modal-label'>Time</span>
            <span className='appointment-modal-value'>{timeLabel}</span>
          </div>
          <div className='appointment-modal-row'>
            <span className='appointment-modal-label'>Lead</span>
            <span className='appointment-modal-value'>{leadName || 'N/R'}</span>
          </div>
          <div className='appointment-modal-row'>
            <span className='appointment-modal-label'>Pipeline</span>
            <span className='appointment-modal-value'>{pipelineName || 'N/R'}</span>
          </div>
          <div className='appointment-modal-row'>
            <span className='appointment-modal-label'>Stage</span>
            <span className='appointment-modal-value'>{stageName || 'N/R'}</span>
          </div>
          {typeAppointment && (
            <div className='appointment-modal-row'>
              <span className='appointment-modal-label'>Type</span>
              <span className='appointment-modal-value'>{typeAppointment}</span>
            </div>
          )}
          {meetingLocation && (
            <div className='appointment-modal-row'>
              <span className='appointment-modal-label'>Location</span>
              <span className='appointment-modal-value'>{meetingLocation}</span>
            </div>
          )}
          {comment && (
            <div className='appointment-modal-row'>
              <span className='appointment-modal-label'>Observations</span>
              <span className='appointment-modal-value'>{comment}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
